import { useState, useMemo } from 'react';
import { useThemeDetector } from '@/helpers/useThemeDetector';
import { themes } from '@/theme/themes';

export type ThemePreference = 'light' | 'dark' | 'system';
type ResolvedMode = 'light' | 'dark';

const STORAGE_KEY = 'user-theme';

const getInitialPreference = (): ThemePreference => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'system') return saved;
    return 'system';
};

export const useThemeMode = () => {
    const systemIsDark = useThemeDetector();
    const [preference, setPreferenceState] = useState<ThemePreference>(getInitialPreference);

    const setPreference = (value: ThemePreference) => {
        setPreferenceState(value);
        if (value === 'system') {
            localStorage.removeItem(STORAGE_KEY);
        } else {
            localStorage.setItem(STORAGE_KEY, value);
        }
    };

    const toggleTheme = () => {
        setPreference(preference === 'light' ? 'dark' : 'light');
    };

    const resolvedMode: ResolvedMode =
        preference === 'system' ? (systemIsDark ? 'dark' : 'light') : preference;

    const theme = useMemo(() => themes[resolvedMode], [resolvedMode]);

    return { theme, mode: resolvedMode, preference, setPreference, toggleTheme };
};
